import { EventEmitterInterface } from 'pf-frontend-common/dist/module/event/emitter.interface';
import { WindowServiceInterface } from 'pf-frontend-common/src/service/window/service.interface';

import { LocationModel } from 'common/data/location/model';
import { buildingReviewLandingFormStatsGtmSubmit } from 'common/module/building-review-landing/form/stats/gtm/submit';
import { BuildingReviewLandingFormTemplatePropsInterface } from 'common/module/building-review-landing/form/template-props.interface';
import { DataStore } from 'common/module/data/store';
import { StatsGtmProviderInterface } from 'common/module/stats/gtm/provider.interface';

export class BuildingReviewLandingFormViewStore extends DataStore {
  /**
   * @inheritdoc
   */
  protected state: BuildingReviewLandingFormTemplatePropsInterface;

  /**
   * @inheritdoc
   */
  public constructor(
    eventEmitter: EventEmitterInterface,
    private windowService: WindowServiceInterface,
    private statsGtm: StatsGtmProviderInterface
  ) {
    super(eventEmitter);
  }

  /**
   * @inheritdoc
   */
  public initialize(): void {
    this.state = {
      location: null,
      showError: false,
      onSubmitForm: this.onSubmitForm,
    };
  }

  /**
   * Set location from autocomplete
   */
  public setLocation(location: LocationModel): void {
    this.state.location = location;
    this.state.showError = false;
    this.setState(this.state);
  }

  /**
   * Submit form
   */
  private onSubmitForm = (e: Event) => {
    e.preventDefault();

    if (!this.state.location) {
      this.state.showError = true;
      this.setState(this.state);

      return;
    }

    this.statsGtm.send(buildingReviewLandingFormStatsGtmSubmit(this.state.location.name));

    this.windowService.getNative().location.href = this.state.location.links.building_reviews;
  };
}
